import { CONTRIBUTION, CONTRIBUTION_ERROR, CONTRIBUTION_HIDE_ERROR, CONTRIBUTION_START_LOADER, CONTRIBUTION_STOP_LOADER, } from "../interface/IContribution";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ContributionReducer = (state = initState, action) => {
    switch (action.type) {
        case CONTRIBUTION: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case CONTRIBUTION_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CONTRIBUTION_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CONTRIBUTION_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CONTRIBUTION_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ContributionReducer;
